module.exports = __webpack_public_path__ + "e56f711380e05b0a23103137f51ab810.png";